import { render, staticRenderFns } from "./awsElasticsearch.vue?vue&type=template&id=cc0cc3a8&"
import script from "./awsElasticsearch.vue?vue&type=script&lang=js&"
export * from "./awsElasticsearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports